<template>
  <div 
    id="app" 
    class="app" 
    :class="{ scrolled: isScrolled, 'simple-layout': simpleLayout }"
  >
    <navbar 
      :simple-nav="simpleLayout"
      :class="[{ 'home-nav' : $route.name == 'home' }, navbarAnimation]" 
      ref="navbar" 
    />
    <!-- <transition name="fade"> -->
      <router-view class="" />
    <!-- </transition> -->
    <footer-section />
  </div>
</template>
<script>
  import Navbar from '@/components/layout/navbar.vue';
  import FooterSection from '@/components/layout/footer.vue';

  export default {
    components: {
      Navbar,
      FooterSection
    },
    data() {
        return {
          isScrolled: false,
          navbarAnimation: '',
          simpleLayout: false
        }
    },
    watch: {
      '$route' (old) {
        if (!this.$route.matched.length) {
          return;
        }
        this.simpleLayout = this.$route.matched[0].path == "*";
      }
    },
    methods: {
      handleScroll (event) {
        if (!this.$refs || !this.$refs.navbar) {
          return;
        }

        const offset = 50;
        const scrollTop = document.scrollingElement.scrollTop;
        const navbarHeight = this.$refs.navbar.$el.offsetHeight;

        if (scrollTop >= navbarHeight + offset) {
          this.isScrolled = true;
          this.navbarAnimation = 'animated slideInDown';
        } else if (scrollTop >= offset)  {
          this.navbarAnimation = 'animated slideOutUp';
        } else {
          this.isScrolled = false;
          this.navbarAnimation = '';
        }
      }
    },
    created () {
      document.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      document.removeEventListener('scroll', this.handleScroll);
    }
  }
</script>
<style lang="scss">
@import "./assets/scss/main";
.app {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;
  background: $white;
}

.simple-layout {
  .footer__contact {
    display: none;
  }
}

.home-nav {
  position: absolute !important;

  .navbar--brand {
      img {
          width:280px;
      }
  }

  .navbar-nav {
      .nav-item {
          margin-right: 15px;

          a {
              color: $white;
              font-size:$extra-small-font-size;

              &.router-link-exact-active {
                  border-bottom:1px solid $white;
                  @media (max-width: 991px) {
                    font-weight: bold;
                    border: none;
                  }
              }

              &:hover {
                border-bottom:1px solid $white;
                @media (max-width: 991px) {
                  font-weight: bold;
                  border: none;
                }
            }
          }
      }
  }
}

[data-scroll-class] {
  opacity: 0;
}
.animated {
    opacity: 1;
}
html:not(.no-js) [data-aos=fade-right] {
  opacity: 1 !important;
  transform: none!important;
}
</style>